'use client';

import { use } from 'react';
import AppUrlParams from '@frameio/shared/routing/params/params';
import { checkIfIdExistsInData } from '@frameio/shared/utils/checkIfIdExistsInData';
import { PAGE_SIZE, SHOW_ALL_ITEMS_PARAM } from '../constants';
import { useGetWhatsNewFeedQuery } from '../gql/queries/generated/GetWhatsNewFeed';

export const useActiveWhatsNewItem = () => {
  const whatsNewItemIdFromParam = use(AppUrlParams.whats_new_item);

  const highlightAll = whatsNewItemIdFromParam === SHOW_ALL_ITEMS_PARAM;
  const { data } = useGetWhatsNewFeedQuery({
    variables: {
      page: {
        first: PAGE_SIZE,
      },
    },
    skip: !whatsNewItemIdFromParam || highlightAll,
  });

  // special case for opening panel without highlighting an individual item
  if (whatsNewItemIdFromParam === SHOW_ALL_ITEMS_PARAM) {
    return {
      activeWhatsNewItemId: SHOW_ALL_ITEMS_PARAM,
    };
  }

  const activeItemId = checkIfIdExistsInData(
    whatsNewItemIdFromParam,
    data?.whatsNewFeed?.items?.nodes
  );

  return {
    activeWhatsNewItemId: activeItemId,
  };
};
